// extracted by mini-css-extract-plugin
export default {"container":"hp-z","ratingLayout":"ip-z","ratingLabel":"jp-z","nonInteractiveRatingLabel":"kp-z"};